<template>
	<div class="authModal">
		<el-dialog title="身份认证审核" :visible.sync="isShow" width="35%" @close="close" :center="true">
			<ul>
                <li class="line">
                	<div class="label">测试：</div>
                	<div class="content">userId:{{currentList.user_id}};authId:{{currentList.auth_id}}</div>
                </li>
				<li class="line">
					<div class="label">公司名称：</div>
					<div class="content">{{currentList.company_name}}</div>
					
				</li >
				<li class="line">
					<div class="label"><span class="red"> * </span> 审核</div>
					<div class="content">
						<el-form ref="form" label-width="0px">
							<el-form-item>
								<el-radio-group v-model="type">
									<el-radio label="1" >通过审核</el-radio>
									<el-radio label="2" >不通过审核</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-form>
					</div>
					
				</li>
				<li v-if="isShowArea" class="line">
					<div class="label"><span class="red"> * </span> 拒绝理由</div>
					<div class="content">
						<textarea name="" id="" cols="30" rows="7" placeholder="请填写拒绝理由" v-model="reason"></textarea>
					</div>
					
				</li>
			</ul>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取 消</el-button>
				<el-button type="primary" @click="submit" v-loading="isLoadingModal">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		utils
	} from '@/common/common.js'
	import { ajaxPost } from '@/common/request.js'
	export default {
		name: 'authmodal',
		data() {
			return {
				type:'',
				reason:'',
				infoObj:{},
				isLoadingModal:"",
				
			}
		},
		props:['current','isShow'],
		components: {
            adminId(){
                return utils.getAdminId()
            }
        },
		computed: {
		  currentList: function () {
			this.reason=""
			this.type=""
			return this.current
		  },
		  isShowArea(){
			if(this.type==1){
				// this.reason=""
				return false
			}
			if(this.type==2){
				// this.reason=""
				return true
			}
		  }
		},
		methods: {
			refresh(){
				this.$emit('submitSucess');
			},
			submit(){
				let _this=this
				console.log(_this.currentList,'_this.currentList')
				if(!this.type){
					_this.$message({
						message: "未选择是否通过",//接口返回一个页面
						type: 'warning',
						duration: 1500
					});
					
				}else if(this.type==2&&!this.reason){
					_this.$message({
						message: "请填写拒绝理由",//接口返回一个页面
						type: 'warning',
						duration: 1500
					});
				}else{
					let args={
						loginUserId:_this.adminId,
						userId:_this.currentList.user_id,
						reason:_this.reason,
						type:_this.type,
						authId:_this.currentList.auth_id,
					}
					console.log(args)
					_this.isLoadingModal=true
					ajaxPost('admin/yijiajiaUserAuth/updateAuthResult',args).then(function(res){
						_this.isLoadingModal=false
						if(res.errorCode==200){
							_this.$message({
								message: "提交成功",//接口返回一个页面
								type: 'success',
								duration: 1500
							});
							_this.refresh()
							_this.close()
						}else{
// 							_this.refresh()
// 							_this.close()
						}
						
					},function(res){
						_this.isLoadingModal=false
					})
				}
				
			},
			close(){
				console.log("emit close")
				this.$emit('close');
			}
		},
		mounted() {
		}
	}
</script>

<style scoped lang="scss">
	.authModal{
		.line{padding:0.2rem;}
		.content{display: inline-block;  padding:0.1rem 0.1rem 0.1rem 0.3rem;min-width: 6rem;vertical-align: top;}
		.label{display: inline-block;background:lightblue;color:#fff;width: 1.8rem;padding:0.1rem 0.2rem;}
		textarea{border:1px solid #aaa;padding:0.2rem;border-radius: 4px;}
	}
	
</style>



// WEBPACK FOOTER //
// src/components/authModal.vue